<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12" class="p-0">
          <TopBarMember class="mb-0 mb-sm-3" />
        </b-col>
      </b-row>
    </b-container>

    <b-container class="px-0 px-sm-3 overflow-hidden">
      <b-card
        header-bg-variant="dark"
        header-border-variant="dark"
        header-text-variant="white"
        header-tag="header"
        body-bg-variant="light"
        border-variant="dark"
        class="main-card"
        body-class="p-1"
      >
        <template #header class="card-header px-0">
          <router-link to="/lotteryset">
            <i class="fas fa-chevron-left"></i> หน้าหลัก
          </router-link>
        </template>
        <b-row class="mb-2">
          <b-col>
            <b-card
              body-class="p-2  d-flex flex-column flex-sm-column flex-md-row justify-content-between"
              class="shadow-sm"
              border-variant="white"
            >
              <h5 class="mb-0 mt-1">
                <i class="fas fa-ticket-alt"></i> หวยฮานอย/เวียดนาม
              </h5>
              <b-button
                size="sm"
                variant="outline-secondary"
                v-b-modal.modal-rules
                class="py-1"
              >กติกา & วิธีเล่น</b-button>
              <b-modal
                id="modal-rules"
                size="lg"
                title="กติกา"
                header-class="text-mitr bg-gold"
                header-bg-variant="warning"
              >
                <h5>เงื่อนไขการแทง หวยชุดฮานอย {{getAppName}}</h5>
                <ul class="ml-3">
                  <li>หวยชุดฮานอยจะออกรางวัลทั้งหมด 5 หมายเลข จะนำตัวเลข 4 ตัวหลังมาใช้ในการออกรางวัล</li>
                  <li>เปิดรับเเทงออนไลน์ตลอด 24 ชั่วโมง สามารถเเทงได้ล่วงหน้าตามเวลาหวยฮานอยปกติ</li>
                  <li>หวยชุดฮานอยจะออกสลากเป็นประจำทุกวัน ตั้งเเต่ เวลา 18:30น.(ตามเวลาประเทศไทย)</li>
                  <li>ปิดรับเเทงเวลา 18:00น. ของทุกวัน (ตามเวลาประเทศไทย)</li>
                </ul>
                <p align="center">1 ชุดสามารถลุ้นรับได้ถึง 6 รางวัล (จำกัดสิทธิ์ชุดละ 1 รางวัล)</p>
                <div class="w-100">
                  <center>
                    <table class="table w-auto">
                      <thead>
                        <tr>
                          <th>ประเภท</th>
                          <th class="text-right">เงินรางวัล</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>ถูก 4 ตัวตร</td>
                          <td class="text-right">90,000 ฿</td>
                        </tr>
                        <tr>
                          <td>ถูก 3 ตัวตรง</td>
                          <td class="text-right">30,000 ฿</td>
                        </tr>
                        <tr>
                          <td>ถูก 4 ตัวโต๊ด</td>
                          <td class="text-right">4,000 ฿</td>
                        </tr>
                        <tr>
                          <td>ถูก 3 ตัวโต๊ด</td>
                          <td class="text-right">3,000 ฿</td>
                        </tr>
                        <tr>
                          <td>ถูก 2 ตัวหน้า</td>
                          <td class="text-right">1,400 ฿</td>
                        </tr>
                        <tr>
                          <td>ถูก 2 ตัวหลัง</td>
                          <td class="text-right">1,400 ฿</td>
                        </tr>
                      </tbody>
                    </table>
                  </center>
                </div>
                <template #modal-footer>
                  <div class="w-100">
                    <b-button
                      variant="secondary"
                      class="float-right golden-btn"
                      @click="$bvModal.hide('modal-rules')"
                    >ฉันเข้าใจและยอมรับ</b-button>
                  </div>
                </template>
              </b-modal>
            </b-card>
          </b-col>
        </b-row>
        <b-row class="mx-0 px-0">
          <b-col class="mt-0 mb-1 py-1 px-1" cols="4">
            <router-link
              :class="((page == 'result' || page === undefined) ? 'btn-warning ' : 'btn-outline-warning ') + 'btn btn-block px-0 h-100'"
              to="/member/lottery/set/hanoi"
            >
              <i class="fas fa-award"></i>
              <br />ผลหวยฮานอย
            </router-link>
          </b-col>
          <b-col class="mt-0 mb-1 py-1 px-1" cols="4">
            <router-link
              :class="(page == 'tang' ? 'btn-warning ' : 'btn-outline-warning ') + 'btn btn-block px-0 h-100'"
              to="/member/lottery/set/hanoi/tang"
            >
              <i class="fas fa-calculator"></i>
              <br />แทงหวยชุดฮานอย
            </router-link>
          </b-col>
          <b-col class="mt-0 mb-1 py-1 px-1" cols="4">
            <router-link
              :class="(page == 'poy' ? 'btn-warning ' : 'btn-outline-warning ') + 'btn btn-block px-0 h-100'"
              to="/member/lottery/set/hanoi/poy"
            >
              <i class="fas fa-tasks"></i>
              <br />รายการที่แทง
            </router-link>
          </b-col>
        </b-row>
        <Result v-if="page === undefined" :lottoInfo="lottoInfo" />
        <Poy v-if="page === 'poy'" :lottoType="lottoType" :lottoInfo="lottoInfo" />
        <Tang v-if="page === 'tang'" :lottoType="lottoType" :lottoInfo="lottoInfo" />
      </b-card>
    </b-container>
    <FooterIndex class="mt-3" />
  </div>
</template>

<script>
import { Component, Vue, Prop } from "vue-property-decorator";

// Include Component
import TopBarMember from "@/components/TopBarMember.vue";
import FooterIndex from "@/components/Footer.vue";
import Result from "@/components/member/lotteryset/hanoi/Result.vue";
import Poy from "@/components/member/lotteryset/hanoi/Poy.vue";
import Tang from "@/components/member/lotteryset/hanoi/Tang.vue";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";

export default {
  name: "LotterySetHanoi",
  props: ["page"],
  components: {
    TopBarMember,
    FooterIndex,
    Result,
    Poy,
    Tang
  },
  data() {
    return {
      lottoInfo: {
      },
      lottoType: 27
    };
  },
  mounted() {
    this.getLottoInfo();
  },
  methods: {
    getLottoInfo() {
      axios.post(this.getApiUrl + "/lottoset/available",
          {
            lottoType: parseInt(this.lottoType)
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername
            }
          }
        )
        .then(response => {
          this.lottoInfo = response.data.data[0];
        });
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getLottoType: "getLottoType",
      getApiUrl: "getApiUrl",
      getAppName: "getAppName"
    })
  }
};
</script>

<style lang="scss" scoped>
.main-card {
  min-height: calc((100vh - 104px) - 49px);
}

.card-header {
  font-size: 90%;
  line-height: 90%;

  a {
    color: #bbbbbb;

    &:hover {
      color: #bd841b;
      text-decoration: none;
    }
  }
}

.bg-gold {
  background-image: linear-gradient(
    160deg,
    #a54e07,
    #b47e11,
    #fef1a2,
    #bc881b,
    #a54e07
  ) !important;
  border: 1px solid #a55d07;
  text-shadow: rgb(0 0 0) 2px 0px 0px, rgb(0 0 0) 1.75517px 0.958851px 0px,
    rgb(0 0 0) 1.0806px 1.68294px 0px, rgb(0 0 0) 0.141474px 1.99499px 0px,
    rgb(0 0 0) -0.832294px 1.81859px 0px, rgb(0 0 0) -1.60229px 1.19694px 0px,
    rgb(0 0 0) -1.97998px 0.28224px 0px, rgb(0 0 0) -1.87291px -0.701566px 0px,
    rgb(0 0 0) -1.30729px -1.5136px 0px, rgb(0 0 0) -0.421592px -1.95506px 0px,
    rgb(0 0 0) 0.567324px -1.91785px 0px, rgb(0 0 0) 1.41734px -1.41108px 0px,
    rgb(0 0 0) 1.92034px -0.558831px 0px;
  font-weight: normal !important;
}

.font-mitr {
  font-family: "Mitr", sans-serif;
}

h5 {
  color: #bd841b;
  font-weight: bold;
}

.btn {
  i {
    font-size: 25px;
  }

  &-warning {
    background-color: #bd841b;
    border-color: #bd841b;
    color: #ffffff;
  }

  &-outline-warning {
    color: #bd841b;
    border-color: #bd841b;
  }

  &:hover,
  &:focus,
  &:active {
    background-color: #bd841b;
    border-color: #bd841b;
    outline: none;
    box-shadow: none;
    color: #ffffff;
  }
}
</style>